import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { useParams } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { CircularProgress, LinearProgress, Tabs, Tab, Box } from "@mui/material";
import PanelDetails from "../../../UI/Panels/View";
import ChangeLogDetails from "../../../UI/Panels/ChangeLog/ChangeLogDetails"; // We'll create this

const ViewPanel = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0); // 0 for panel details, 1 for change logs
  const [formData, setFormData] = useState({
    smmpanel_name: "",
    smmpanel_loginuser: "",
    smmpanel_login_password: "",
    smmpanel_api_key: "",
    smmpanel_api_url: "",
    smmpanel_ticket_numper: "",
    smmpanel_date_of_ticket: null,
    smmpanel_url: "",
    description: "",
    smmpanel_email: "",
    smmpanel_instagram: "",
    smmpanel_skype: "",
    smmpanel_telegram: "",
    smmpanel_fb: "",
    smmpanel_twitter: "",
    smmpanel_whatsapp: "",
    smmpanel_tel1: "",
    reading_status: "",
    customLogo: "",
    logo: null,
    smmpanel_notice: "",
    url_service: "",
    trust: 0,
    expired: "",
    smmpanel_domain_registered: "",
    smmpanel_domain_expires: "",
    country_name: "",
    screenShot: null,
    payment_method: [],
    count_review: 0,
    reviews: [],
    rate: {},
    services: [],
    pagination: {},
    photos: [],
  });
  const [changeLogs, setChangeLogs] = useState([]);
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Panels.GetOne}${id}`,
      });

      if (response) {
        setFormData({
          smmpanel_name: response?.data?.panel_details?.smmpanel_name || "",
          smmpanel_loginuser:
              response?.data?.panel_details?.smmpanel_loginuser || "",
          smmpanel_login_password:
              response?.data?.panel_details?.smmpanel_login_password || "",
          smmpanel_api_key:
              response?.data?.panel_details?.smmpanel_api_key || "",
          smmpanel_api_url:
              response?.data?.panel_details?.smmpanel_api_url || "",
          smmpanel_ticket_numper:
              response?.data?.panel_details?.smmpanel_ticket_numper || "",
          smmpanel_date_of_ticket:
              response?.data?.panel_details?.smmpanel_date_of_ticket || null,
          smmpanel_url: response?.data?.panel_details?.smmpanel_url || "",
          description: response?.data?.panel_details?.description || "",
          smmpanel_email: response?.data?.panel_details?.smmpanel_email || "",
          smmpanel_instagram:
              response?.data?.panel_details?.smmpanel_instagram || "",
          smmpanel_skype: response?.data?.panel_details?.smmpanel_skype || "",
          smmpanel_telegram:
              response?.data?.panel_details?.smmpanel_telegram || "",
          smmpanel_fb: response?.data?.panel_details?.smmpanel_fb || "",
          smmpanel_twitter:
              response?.data?.panel_details?.smmpanel_twitter || "",
          smmpanel_whatsapp:
              response?.data?.panel_details?.smmpanel_whatsapp || "",
          smmpanel_tel1: response?.data?.panel_details?.smmpanel_tel1 || "",
          reading_status: response?.data?.panel_details?.reading_status || "",
          reading_type: response?.data?.panel_details?.reading_type || "",
          customLogo: response?.data?.panel_details?.customLogo || "",
          logo: response?.data?.panel_details?.logo || null,
          smmpanel_notice: response?.data?.panel_details?.smmpanel_notice || "",
          url_service: response?.data?.panel_details?.url_service || "",
          trust: response?.data?.panel_details?.trust || 0,
          expired: response?.data?.panel_details?.expired || "",
          smmpanel_domain_registered:
              response?.data?.panel_details?.smmpanel_domain_registered || "",
          smmpanel_domain_expires:
              response?.data?.panel_details?.smmpanel_domain_expires || "",
          country_name: response?.data?.panel_details?.country_name || "",
          screenShot: response?.data?.panel_details?.screenShot || "",
          payment_method:
              response?.data?.payment_method?.length > 0
                  ? response?.data?.payment_method?.map((method) => method.type)
                  : [],
          count_review: response?.data?.count_review,
          reviews: response?.data?.reviews,
          rate: response?.data?.rate,
          services: response?.data?.services,
          pagination: response?.data?.pagination,
          photos: response?.data?.panel_details.photos || [],
        });

        // Set change logs if available in response
        if (response?.data?.panel_details?.change_logs) {
          setChangeLogs(response.data.panel_details.change_logs);
        }
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchChangeLogs = async () => {
    if (changeLogs.length > 0) return; // Already loaded

    try {
      setIsLoadingLogs(true);
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Panels.GetOne}${id}?include_change_logs=1`,
      });

      if (response?.data?.panel_details?.change_logs) {
        setChangeLogs(response.data.panel_details.change_logs);
      }
    } catch (error) {
      console.error("Error fetching change logs:", error);
    } finally {
      setIsLoadingLogs(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (activeTab === 1) {
      fetchChangeLogs();
    }
  }, [activeTab]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    if (isLoading) {
      return <LinearProgress />;
    }

    switch (activeTab) {
      case 0:
        return <PanelDetails data={formData} />;
      case 1:
        return <ChangeLogDetails changeLogs={changeLogs} isLoading={isLoadingLogs} />;
      default:
        return <PanelDetails data={formData} />;
    }
  };

  return (
      <div>
        <PanelHead
            title={
              isLoading ? (
                  <div className="flex items-center gap-4">
                    Panel details <CircularProgress size={24} />
                  </div>
              ) : (
                  <div className="flex items-center justify-between w-full gap-4">
                    <div>Panel details: {formData?.smmpanel_name}</div>
                  </div>
              )
            }
        />

        {/* Tabs Navigation */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
          <Tabs value={activeTab} onChange={handleTabChange} aria-label="panel details tabs">
            <Tab label="Panel Details" />
            <Tab
                label={
                  <div className="flex items-center gap-2">
                    Change Logs
                    {changeLogs.length > 0 && (
                        <span className="bg-blue-500 text-white text-xs rounded-full px-2 py-1 min-w-5 h-5 flex items-center justify-center">
                    {changeLogs.length}
                  </span>
                    )}
                  </div>
                }
            />
          </Tabs>
        </Box>

        <PanelBody content={renderTabContent()} />
      </div>
  );
};

export default React.memo(ViewPanel);